"use client"

import { locales, usePathname, useRouter, type Locale } from "@/i18n/routing";
import { useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { useParams } from "next/navigation";
import { useLocale } from "next-intl";

// const locales: readonly ["de", "en", "fr", "it", "es", "pl", "cs", "nl", "sv", "no", "fi", "da", "ru"]


function getLanguageIcon(locale: Locale): string {
  switch (locale) {
    case "de":
      return "🇩🇪";
    case "en":
      return "🇬🇧";
    case "fr":
      return "🇫🇷";
    case "es":
      return "🇪🇸";
    case "it":
      return "🇮🇹";
    case "ru":
      return "🇷🇺";
    case "pl":
      return "🇵🇱";
    case "cs":
      return "🇨🇿";
    case "nl":
      return "🇳🇱";
    case "sv":
      return "🇸🇪";
    case "no":
      return "🇳🇴";
    case "fi":
      return "🇫🇮";
    case "da":
      return "🇩🇰";
    default:
      return "";
  }
}


export default function LocaleSwitcher() {  

  const pathname = usePathname()  
  const params = useParams();
  const currentLocale = useLocale()
  
 

  const router = useRouter()
  const [value, setValue] = useState(currentLocale)


  const onValueChange = (value: string) => {
    setValue(value)   
    
    // router.replace(pathName, { "locale": value })
    router.replace(
      {
        pathname: pathname,
        // TypeScript will validate that only known `params` are used in combination
        // with a given `pathname`. Since the two will always match for the current
        // route, we can skip runtime checks.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        params: params as any
        // params: {
        //   category: params.category,
        //   subcategory: params.subcategory,
        //   slug: params.slug[0]     

        // }
      },
      {locale: value}
    )
  }

  return (
    <>
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger aria-label="language switcher" className="w-[120px]">
          <SelectValue  />
        </SelectTrigger>
        <SelectContent>
          {locales.map((locale) => {
            return (
              <SelectItem key={locale} value={locale}>
                {getLanguageIcon(locale)} {locale.toUpperCase()}
              </SelectItem>
            )
          })}
        </SelectContent>
      </Select>
    </>
  )
}
